import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchGamesListRequest = () => ({
  type: actionTypes.FETCH_GAMES_LIST_REQUEST,
  name: 'manageInventoryLoadingStatus',
});

export const fetchGamesListSuccess = (games, pagination) => ({
  type: actionTypes.FETCH_GAMES_LIST_SUCCESS,
  name: 'manageInventoryLoadingStatus',
  games,
  pagination,
});

export const fetchGamesListFailure = () => ({
  type: actionTypes.FETCH_GAMES_LIST_FAILURE,
  name: 'manageInventoryLoadingStatus',
});

export const fetchGamesList = (config) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(fetchGamesListRequest());

    const { content, ...pagination } = await api.fetchGamesList(requestParams);
    dispatch(fetchGamesListSuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_GAMES_LIST', error);
    dispatch(fetchGamesListFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-games-list.actions.js